import React, { useState, useEffect, useCallback } from "react";
import RCTable from "rc-table";
import "rc-pagination/assets/index.less";
import "./table.scss";
import "rc-select/assets/index.less";
import IPagination from "../Pagination/IPagination";
export default function Table({
  title,
  columns,
  initialData = [],
  getData,
  pagination,
}: {
  title: string;
  columns: any;
  initialData?: any;
  getData?: ({
    limit = 50,
    offset = 1,
  }: {
    limit?: number;
    offset?: number;
  }) => void;
  pagination?: any;
}) {
  const [data, setData] = useState(initialData);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState();
  const [pageSize, setPageSize] = useState(50);
  const loadData = useCallback(
    async (
      getData: ({
        limit = 50,
        offset = 0,
      }: {
        limit?: number;
        offset?: number;
      }) => void
    ) => {
      let res: any = await getData({ limit: 50, offset: 0 });
      if (res?.data && res?.count !== 0) {
        setCount(res?.count);
        setData(res?.data);
      }
    },
    []
  );
  const onPage = useCallback(
    async (page: any) => {
      if (getData) {
        let offset = (page - 1) * pageSize;
        let res: any = await getData({ limit: pageSize, offset: offset });
        if (res?.data && res?.count !== 0) {
          setCount(res?.count);
          setData(res?.data);
          setPage(page);
        }
      }
    },
    [getData, pageSize]
  );
  const onShowSizeChange = useCallback(
    async (current: any, pageSize: any) => {
      setPageSize(pageSize);
      setPage(current);
      let offset = (current - 1) * pageSize;
      if (getData) {
        let res: any = await getData({ limit: pageSize, offset: offset });
        if (res?.data && res?.count !== 0) {
          setCount(res?.count);
          setData(res?.data);
        }
      }
    },
    [getData]
  );
  useEffect(() => {
    if (getData) {
      loadData(getData);
    }
  }, [getData, loadData]);
  return (
    <div className="table">
      <div className="t-title">{title === "BSC" ? "BNB Chain" : title}</div>
      <RCTable
        data={data}
        columns={columns}
        footer={() =>
          pagination && (
            <IPagination
              page={page}
              count={count}
              pageSize={pageSize}
              onPage={onPage}
              onShowSizeChange={(current: any, pageSize: any) =>
                onShowSizeChange(current, pageSize)
              }
            />
          )
        }
      />
    </div>
  );
}
